// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn-with-badge__wrapper[data-v-5fb51c77]:hover{cursor:pointer}", ""]);
// Exports
module.exports = exports;
